<mat-dialog-content class="contact-agent">
    <h4>Send a Message</h4>
    <p>Connect with {{agentNameDisplay$ | async}} about this quote.</p>

    <mat-form-field appearance="outline" floatLabel="always" style="width:100%;">
        <mat-label>Message</mat-label>
        <textarea matInput [(ngModel)]="message" minlength="10" maxlength="1000" cdkTextareaAutosize
            placeholder="Type your message here." #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="10"></textarea>
    </mat-form-field>

    <p>Linked Quote:</p>

    <table *ngIf="opportunity as o">
        <tr>
            <td style="width: 200px;"><strong>Rate / APR</strong></td>
            <td>{{o?.opportunityInfo?.matchedRate}}% | {{o?.opportunityInfo?.matchedApr}}%</td>
        </tr>
        <tr>
            <td style="width: 200px;"><strong>Points / Price</strong></td>
            <td>{{o?.opportunityInfo?.points}}% | {{o?.opportunityInfo?.matchedPrice}}%</td>
        </tr>
        <tr>
            <td style="width: 200px;"><strong>Points Cost</strong></td>
            <td>{{o?.opportunityInfo?.pointsCost | currency:'USD':'symbol':'1.0-0'}}</td>
        </tr>
        <tr>
            <td style="width: 200px;"><strong>Monthly P&I</strong></td>
            <td>{{o?.opportunityInfo?.points | currency:'USD':'symbol':'1.0-0'}}</td>
        </tr>
        <tr>
            <td style="width: 200px;"><strong>Mortgage Interest</strong></td>
            <td>{{o?.opportunityInfo?.marketMonthlyPaymentMi | currency:'USD':'symbol':'1.0-0'}}</td>
        </tr>
        <tr>
            <td style="width: 200px;"><strong>Lock Period (Days)</strong></td>
            <td>{{o?.opportunityInfo?.lockPeriod}}</td>
        </tr>
        <tr>
            <td style="width: 200px;"><strong>Loan Amount</strong></td>
            <td>{{o?.opportunityInfo?.loanAmount | currency:'USD':'symbol':'1.0-0'}}</td>
        </tr>
    </table>

    <div mat-dialog-actions class="float-end">
        <button mat-button (click)="dialogRef.close()">Cancel</button>
        <button type="button" class="btn btn-secondary" (click)="onSendEmail()">Send</button>
    </div>


</mat-dialog-content>